/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiserviceMelcoModelsUserAlphabet,
    ApiserviceMelcoModelsUserAlphabetFromJSON,
    ApiserviceMelcoModelsUserAlphabetFromJSONTyped,
    ApiserviceMelcoModelsUserAlphabetToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiserviceMelcoModelsDesignLetteringElement
 */
export interface ApiserviceMelcoModelsDesignLetteringElement {
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    alphabet_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    angle?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    width_factor?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    slant_angle?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    tracking?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    rotation_direction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    layout_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    justification?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    radius?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    horizontal_stitch_order?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    vertical_stitch_order?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    connection_type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    continuous_underlay?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    default_text?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    text_max_length?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    default_alphabet_id?: string | null;
    /**
     * 
     * @type {Array<ApiserviceMelcoModelsUserAlphabet>}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    alphabet_list?: Array<ApiserviceMelcoModelsUserAlphabet> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiserviceMelcoModelsDesignLetteringElement
     */
    renderer_index?: number;
}

export function ApiserviceMelcoModelsDesignLetteringElementFromJSON(json: any): ApiserviceMelcoModelsDesignLetteringElement {
    return ApiserviceMelcoModelsDesignLetteringElementFromJSONTyped(json, false);
}

export function ApiserviceMelcoModelsDesignLetteringElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiserviceMelcoModelsDesignLetteringElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': !exists(json, 'text') ? undefined : json['text'],
        'alphabet_name': !exists(json, 'alphabet_name') ? undefined : json['alphabet_name'],
        'angle': !exists(json, 'angle') ? undefined : json['angle'],
        'width_factor': !exists(json, 'width_factor') ? undefined : json['width_factor'],
        'slant_angle': !exists(json, 'slant_angle') ? undefined : json['slant_angle'],
        'tracking': !exists(json, 'tracking') ? undefined : json['tracking'],
        'rotation_direction': !exists(json, 'rotation_direction') ? undefined : json['rotation_direction'],
        'layout_type': !exists(json, 'layout_type') ? undefined : json['layout_type'],
        'justification': !exists(json, 'justification') ? undefined : json['justification'],
        'radius': !exists(json, 'radius') ? undefined : json['radius'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'horizontal_stitch_order': !exists(json, 'horizontal_stitch_order') ? undefined : json['horizontal_stitch_order'],
        'vertical_stitch_order': !exists(json, 'vertical_stitch_order') ? undefined : json['vertical_stitch_order'],
        'connection_type': !exists(json, 'connection_type') ? undefined : json['connection_type'],
        'continuous_underlay': !exists(json, 'continuous_underlay') ? undefined : json['continuous_underlay'],
        'default_text': !exists(json, 'default_text') ? undefined : json['default_text'],
        'text_max_length': !exists(json, 'text_max_length') ? undefined : json['text_max_length'],
        'default_alphabet_id': !exists(json, 'default_alphabet_id') ? undefined : json['default_alphabet_id'],
        'alphabet_list': !exists(json, 'alphabet_list') ? undefined : (json['alphabet_list'] === null ? null : (json['alphabet_list'] as Array<any>).map(ApiserviceMelcoModelsUserAlphabetFromJSON)),
        'renderer_index': !exists(json, 'renderer_index') ? undefined : json['renderer_index'],
    };
}

export function ApiserviceMelcoModelsDesignLetteringElementToJSON(value?: ApiserviceMelcoModelsDesignLetteringElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'alphabet_name': value.alphabet_name,
        'angle': value.angle,
        'width_factor': value.width_factor,
        'slant_angle': value.slant_angle,
        'tracking': value.tracking,
        'rotation_direction': value.rotation_direction,
        'layout_type': value.layout_type,
        'justification': value.justification,
        'radius': value.radius,
        'height': value.height,
        'horizontal_stitch_order': value.horizontal_stitch_order,
        'vertical_stitch_order': value.vertical_stitch_order,
        'connection_type': value.connection_type,
        'continuous_underlay': value.continuous_underlay,
        'default_text': value.default_text,
        'text_max_length': value.text_max_length,
        'default_alphabet_id': value.default_alphabet_id,
        'alphabet_list': value.alphabet_list === undefined ? undefined : (value.alphabet_list === null ? null : (value.alphabet_list as Array<any>).map(ApiserviceMelcoModelsUserAlphabetToJSON)),
        'renderer_index': value.renderer_index,
    };
}


